import { render, staticRenderFns } from "./shipmentRecord.vue?vue&type=template&id=602554f4&scoped=true"
import script from "./shipmentRecord.vue?vue&type=script&lang=js"
export * from "./shipmentRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "602554f4",
  null
  
)

export default component.exports